<section #statisticsSection class="web-statistics">
  <div class="web-statistics__inner">
    <div class="box-border box-border--left box-border--top"></div>
    <div class="box-border box-border--right box-border--top"></div>
    <div class="box-border box-border--left box-border--bottom"></div>
    <div class="box-border box-border--right box-border--bottom"></div>

    <div class="web-statistics__inner-content">
      <div class="web-statistics__inner-content-item">
        <span #counter class="web-statistics__inner-content-item-title">{{
          'landing.statistics.driversValue' | translate
        }}</span>
        <span class="web-statistics__inner-content-item-description">
          {{ 'landing.statistics.driversDescription' | translate }}
        </span>
      </div>

      <div class="web-statistics__inner-content-item">
        <span
          #counter
          class="web-statistics__inner-content-item-title web-statistics__inner-content-item-title--green"
        >
          {{ 'landing.statistics.insuredValue' | translate }}
        </span>
        <span class="web-statistics__inner-content-item-description">
          {{ 'landing.statistics.insuredDescription' | translate }}
        </span>
      </div>

      <div class="web-statistics__inner-content-item">
        <span #counter class="web-statistics__inner-content-item-title">{{
          'landing.statistics.bookingValue' | translate
        }}</span>
        <span class="web-statistics__inner-content-item-description">
          {{ 'landing.statistics.bookingDescription' | translate }}
        </span>
      </div>

      <div class="web-statistics__inner-content-item">
        <span class="web-statistics__inner-content-item-title">
          {{ 'landing.statistics.sameDayTitle' | translate }}
          <span class="web-statistics__inner-content-item-title-subtitle">{{
            'landing.statistics.sameDaySubtitle' | translate
          }}</span>
        </span>
        <span class="web-statistics__inner-content-item-description">{{
          'landing.statistics.payDescription' | translate
        }}</span>
      </div>
    </div>
  </div>
</section>
